import React from "react";
import SectionTitle from "../../components/section-title";
import Widget from "../../components/widget";
import BlogForm from "../../components/blog/BlogForm";

const BlogCreate = () => (
  <>
    <SectionTitle title="Create Blog" subtitle="Blogs" />
    <Widget>
      <BlogForm mode="create" />
    </Widget>
  </>
);

export default BlogCreate;
